const config = {
  shopName: 'Ee Kurt Barbers',
  shopAddress: '318 St John Street, London EC1V 4NT',
  shopPhone: '020 7833 1525',
  shopEmail: 'eekurtbookings@gmail.com',
  shopWhatsApp: '447577487547',
  
  // Platform Settings
  platforms: {
    booksy: {
      depositEnabled: true,
      depositAmount: 10,
    },
    fresha: {
      depositEnabled: false,
      depositAmount: 0,
    },
  },
  // Apps Script URL (legacy)
  scriptUrl: 'https://script.google.com/macros/s/AKfycbymASCa4MN7LMPoPa6fYwfeu2OCYfxKlLvoIBlauXhe_o7BDMF5DFgrrpBtUIrZAZi_/exec',
  // Cloud Functions
  sendReceiptUrl: 'https://sendreceipt-nq2q3jgd6a-uc.a.run.app',
  
  // Feature flags
  loyaltyEnabled: false,

  // Admin password (change this!)
  adminPassword: 'eekurt2026',
  // Opening hours
  hours: {
    Monday: { open: '09:00', close: '19:00', closed: false },
    Tuesday: { open: '09:00', close: '19:00', closed: false },
    Wednesday: { open: '09:00', close: '19:00', closed: false },
    Thursday: { open: '09:00', close: '19:00', closed: false },
    Friday: { open: '09:00', close: '19:00', closed: false },
    Saturday: { open: '09:00', close: '19:00', closed: false },
    Sunday: { open: '10:00', close: '16:00', closed: false },
  },

  // Barbers — loaded dynamically from Firestore
  barbers: [],

  // Services — loaded dynamically from Firestore via loadServicesIntoConfig()
  services: [],
};

export const seedServices = [];

export default config;
